import TextButton, { Button } from "@components/buttons/TextButton"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import colors from "@constants/colors"
import { body14BoldStyles, body14Styles } from "@constants/typography"
import { getProductThumbnailAlt } from "@utils/altText"
import { getProductURL } from "@utils/urls"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  padding: 16px;
  border: 1px solid ${colors.dividerLineGray};
  border-radius: 6px;
  background-color: ${colors.dealGray};

  ${Button} {
    flex-grow: 0;
    flex-shrink: 0;
    width: initial;
    height: 40px;
    padding: 0 20px;
  }
`

const GatsbyLink = styled(Link)<{ to: string }>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
`

export const ImageWrapper = styled.div`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  width: 80px;
  height: 80px;

  ${ImageHelperContainer} {
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;

    img {
      object-fit: contain;
    }
  }
`

const Content = styled.div`
  width: 100%;
  margin-right: 16px;
`

const Row = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  display: flex;
`

const Deal = styled.div`
  ${body14Styles};
  margin-bottom: 16px;
  color: ${colors.brandOrange};
`

const ProductName = styled.div`
  ${body14BoldStyles}
  margin-bottom: 8px;
`

const Price = styled.div`
  ${body14Styles}
`

const DiscountedPrice = styled(Price)`
  margin-right: 8px;
  text-decoration: line-through;
  color: ${colors.mediumGray};
`

interface DiscountBlockProps {
  buttonText: string
  deal: string
  discountedPrice?: string
  image: string
  onClick: any
  price?: string
  productName: string
  slug?: string
}

const DiscountBlock: React.FC<DiscountBlockProps> = ({
  buttonText,
  deal,
  discountedPrice,
  image,
  onClick,
  price,
  productName,
  slug = "",
}) => {
  return (
    <Container>
      <Deal>{deal}</Deal>
      <Row>
        <GatsbyLink to={slug ? getProductURL(slug) : ""}>
          <ImageWrapper>
            <ImageHelper
              alt={getProductThumbnailAlt(productName)}
              src={image}
            />
          </ImageWrapper>
        </GatsbyLink>
        <Content>
          <GatsbyLink to={slug ? getProductURL(slug) : ""}>
            <ProductName>{productName}</ProductName>
          </GatsbyLink>
          <Row>
            {discountedPrice && (
              <DiscountedPrice>{`$${discountedPrice}`}</DiscountedPrice>
            )}
            {price && <Price>{`$${price}`}</Price>}
          </Row>
        </Content>
        <TextButton
          onClick={(e) => {
            e.stopPropagation()
            if (onClick) onClick()
          }}
          text={buttonText}
        ></TextButton>
      </Row>
    </Container>
  )
}

export default DiscountBlock
